import { Tag } from 'antd'
import React from 'react'

export const renderIsCompliant = (isCompliant: boolean) => <IsCompliant isCompliant={isCompliant} />

export const renderYesNo = (value: boolean) => (value ? 'Yes' : 'No')

export const IsCompliant = ({ isCompliant }: { isCompliant: boolean }) => (
  <Tag color={isCompliant ? 'blue' : 'red'}>{renderYesNo(isCompliant)}</Tag>
)
